

import React, { useState, useEffect } from 'react';
import '../..//CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from 'react-toastify';


const BoostHistoryTable = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [payments, setPayments] = useState([]);



    const [filteredPayments, setFilteredPayments] = useState(payments);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const url = process.env.REACT_APP_LINK

    useEffect(() => {
        const filtered = payments.filter((payment) => {
            const matchesSearch = Object.values(payment).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            );

            const paymentDate = new Date(payment.date || payment.createdAt).toISOString().slice(0, 10);
            const matchesDate = (
                (!startDate || paymentDate >= startDate) &&
                (!endDate || paymentDate <= endDate)
            );

            return matchesSearch && matchesDate;
        });

        setFilteredPayments(filtered);
        setCurrentPage(1);
    }, [searchQuery, startDate, endDate, payments]);


    const totalPages = Math.ceil(filteredPayments.length / itemsPerPage);
    const currentData = filteredPayments.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                const response = await fetch(`${url}/api/boostvideo/admin1997`);
                const res = await response.json();

                const data = res.data.map((item) => ({
                    ...item,
                    video: item.video ? JSON.parse(item.video) : null,
                }));

                // ✅ sort newest first (safe check for createdAt)
                // parsedPayments.sort((a, b) => {
                //     const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
                //     const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
                //     return dateB - dateA;
                // });

                setPayments(data);
            } catch (error) {
                console.error("Failed to fetch payment history:", error);
            }
        };

        fetchPayments();
    }, []);



    const handleDownloadExcel = () => {
        const paidPayments = filteredPayments.filter(
            (p) => (p.status || '').toLowerCase() === 'success'
        );

        if (paidPayments.length === 0) {
            toast.info("No paid records to download.");
            return;
        }

        const formatted = paidPayments.map(p => ({
            UserID: p.user_id,
            Name: p.name || "N/A",
            Subscription: p.subscription?.title,
            Amount: p.amount,
            Date: p.createdAt?.slice(0, 10),
            TransactionID: p.order_id || 'N/A',
            PaymentStatus: p.status || 'N/A'
        }));

        const worksheet = XLSX.utils.json_to_sheet(formatted);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Paid History");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "paid_payment_history.xlsx");
    };




    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">Boost History</h1>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                        <button className='oms-add-btn mainbuttoncheck' onClick={handleDownloadExcel}><i
                            className="fa fa-download"></i> Excel</button>
                    </div>
                </div>
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Title</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>User ID</th>
                                <th>Name</th>
                                <th>Transaction ID</th>
                                {/* <th>Payment Status</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                        <td>{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                                        <td>{item.video?.title || "N/A"}</td>
                                        <td>₹{item.amount}</td>
                                        <td
                                            className={`${item.status === "Success" ? "text-xolorstatpass" : "text-colorstatfail"}`}
                                        >{item.status==="Pending"?"Failed":"Success"}</td>
                                        <td>{item.user_id}</td>
                                        <td>{item.user_name || "N/A"}</td>
                                        <td>{item.order_id || 'N/A'}</td>
                                        {/* <td>{payment.createdAt?.slice(0, 10)}</td>
                                        <td>{payment.order_id || 'N/A'}</td>
                                        <td>{payment.status || 'Unpaid'}</td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>No payments found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">{currentPage}</button>

                    {currentPage + 1 < totalPages && (
                        <>
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                            {currentPage + 2 < totalPages && <span className="dots">...</span>}
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    {currentPage === totalPages - 1 && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>
        </>
    );
};

export default BoostHistoryTable;
